import { config } from "~/config"
import { useSystemLanguageStoreHook } from "~/store/modules/systemLaunage"
import useUserStore, { useUserStoreHook } from "~/store/modules/user"
import { NetCode, Token } from "~/types/const"
import Toast from "~/utils/toast";

export interface Response<T> {
    code: string
    message: string,
    data?: T
    [x: string]: any
}

interface DefaultOptions {
    method: 'get' | 'post' | 'put'
    params?: any
    body?: any
    data?: any
    headers?: Record<string, any>
    [x: string]: any
}

interface IRequest {
   
}

type RequestOptions = {
    headers?: Record<string, any>
    uploadFlag?: boolean
    onProgress?: (progress: string) => void
    signal?: AbortSignal
    timeout?: number // 超时时间（毫秒），默认 30 分钟
    contentType?: 'application/json' | 'application/x-www-form-urlencoded'  // 请求体编码格式
}

export interface RequestResult<T> {
    promise: Promise<Response<T>>
    cancel: () => void
}

// 生成设备ID的辅助函数
function generateDeviceId(): string {
    // 生成一个简单的UUID作为fallback
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

// 获取或生成设备ID
function getOrCreateDeviceId(): string {
    let deviceId = localStorage.getItem("deviceId");

    if (!deviceId) {
        // 如果localStorage中没有deviceId，生成一个新的
        deviceId = generateDeviceId();
        try {
            localStorage.setItem("deviceId", deviceId);
            console.log('[Request] Generated new deviceId:', deviceId);
        } catch (e) {
            console.error('[Request] Failed to save deviceId to localStorage:', e);
        }
    }

    return deviceId;
}

class HttpRequest {
    static request<T>(url: string, method: 'get' | 'post' | 'put', params: any = {}, options?: RequestOptions): Promise<Response<T>> | RequestResult<T> {
        // console.log("request uploadFlag", options?.uploadFlag, params)
        // 检测操作系统的函数
        function detectOS() {
            // console.log('navigator.platform', navigator)
            const platform = navigator.platform;
            const userAgent = navigator.userAgent;
            if (/Win/i.test(platform) || /Win/i.test(userAgent)) {
                return 'web-windows';
            } else if (/Mac/i.test(platform) || /Mac/i.test(userAgent)) {
                return 'web-mac';
            } else {
                return 'web';
            }
        }
        let pathUrls = ['api/user/trade/save','api/user/basic/qqauth/code/login']
        let isUpload: boolean = options?.uploadFlag || false
        let isDevelopment = process.env.NODE_ENV === 'development'
         // 获取请求的路径是不是/api/user/trade/save，如果是才设置detectOS
         const path = url
         // 判断当前路径是否在目标列表中
        const isTargetPath = pathUrls.some(url => path?.includes(url))
        const platform = isTargetPath ? detectOS() : 'web'
        const lang = useCookie('lang') || ''
        const deviceId = getOrCreateDeviceId()
        const browserInfo = getBrowserInfo() || []
        let langCode = ""
        if (lang.value) {
            langCode = lang.value
            if (lang.value == 'zh') {
                langCode = "zh-CN"
            }else if (lang.value == 'hi') {
                langCode = "hib"
            }else if (lang.value == 'tw') {
                langCode = "zh-TW"
            }
        }
        console.log('langCode===',useCookie('lang'), langCode)

        let defaultOptions: DefaultOptions = {
            method,
            ...options,
            headers: {
                'internationalCode': langCode,
                "Accept": "application/json",
                clienttype: 'web',
                'appSource': platform,
                'deviceName': browserInfo.length > 0 ? browserInfo[0] : '',
                deviceid: deviceId,
                ...options?.headers
            },
        }
        function getBrowserInfo()
        {
            var agent = navigator.userAgent.toLowerCase() ;
            var regStr_ie = /msie [\d.]+;/gi ;
            var regStr_ff = /firefox\/[\d.]+/gi
            var regStr_chrome = /chrome\/[\d.]+/gi ;
            var regStr_saf = /safari\/[\d.]+/gi ;
            //IE
            if(agent.indexOf("msie") > 0)
            {
                return agent.match(regStr_ie) ;
            }

            //firefox
            if(agent.indexOf("firefox") > 0)
            {
                return agent.match(regStr_ff) ;
            }

            //Chrome
            if(agent.indexOf("chrome") > 0)
            {
                return agent.match(regStr_chrome) ;
            }

            //Safari
            if(agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0)
            {
                return agent.match(regStr_saf) ;
            }

        }
        if (isDevelopment) {
            defaultOptions.headers = {
                ...defaultOptions.headers,
                token: useUserStore().token || useCookie(Token).value || ''
            }
        }else {
            defaultOptions.headers = {
                ...defaultOptions.headers,
                token: useUserStore().token || useCookie(Token).value || '',
            }
        }
        
        if (method === 'get') {
            defaultOptions.params = params
        } else if (method === 'post') {
            if (!isUpload) {
                if (options?.contentType === 'application/x-www-form-urlencoded') {
                    const flatParams = typeof params === 'object' && params !== null
                        ? Object.fromEntries(
                            Object.entries(params).filter(([, v]) => v !== undefined).map(([k, v]) => [k, String(v)])
                        )
                        : {}
                    defaultOptions.body = new URLSearchParams(flatParams).toString()
                    defaultOptions.headers = { ...defaultOptions.headers, 'Content-Type': 'application/x-www-form-urlencoded' }
                } else {
                    defaultOptions.body = JSON.stringify(params)
                }
            } else {
                defaultOptions.body = params.data
            }
        }
        url = url && url.startsWith('http') ? url : useRuntimeConfig().public.apiUrl + url

        console.log("defaultOptions ==== ", url)
        
        // 如果上传请求，返回包含 cancel 方法的对象
        if (isUpload) {
            let xhr: XMLHttpRequest | null = null
            let abortController: AbortController | null = null
            let isAborted = false
            
            // 创建 AbortController（如果用户没有提供）
            if (!options?.signal) {
                abortController = new AbortController()
            }
            
            const promise = new Promise<Response<T>>((resolve, reject) => {
                console.log("defaultOptions ==== 111")
                // 直接使用 XHR 实现上传与进度，避免 $fetch 触发额外请求
                xhr = new XMLHttpRequest()
                
                // 设置超时时间，优先使用传入的 timeout，否则使用默认 30 分钟
                const timeout = options?.timeout || 30 * 60 * 1000; // 默认 30 分钟
                xhr.timeout = timeout
                
                // 监听超时事件
                xhr.ontimeout = () => {
                    if (isAborted) {
                        return
                    }
                    isAborted = true
                    const err = new Error(`Request timeout (${timeout / 1000 / 60} minutes)`)
                    if (config.requestLog) {
                        console.error('requestLog timeout error', err)
                    }
                    reject(err)
                }
                
                // 监听取消信号
                const signal = options?.signal || abortController?.signal
                if (signal) {
                    signal.addEventListener('abort', () => {
                        isAborted = true
                        if (xhr) {
                            xhr.abort()
                        }
                    })
                }
                
                xhr.open((defaultOptions.method || 'POST').toUpperCase(), url)

                for (const [key, value] of Object.entries(defaultOptions.headers || {})) {
                    if (value !== undefined && value !== null) {
                        xhr.setRequestHeader(key, String(value))
                    }
                }

                xhr.responseType = 'text'

                xhr.upload.onprogress = (event) => {
                    if (event.lengthComputable && !isAborted) {
                        const progress = (event.loaded / event.total).toFixed(2)
                        if (options && options.onProgress) {
                            options.onProgress(progress)
                        }
                    }
                }

                xhr.onload = () => {
                    if (isAborted) {
                        reject(new Error('Request aborted'))
                        return
                    }
                    try {
                        const text = xhr?.responseText || ''
                        const json = text ? JSON.parse(text) : {}
                        const response = json as Response<T>
                        if (response && response.code === NetCode.TOKEN_EXPIRED) {
                            useUserStoreHook().tokenFail()
                            resolve(response)
                        } else {
                            resolve(response)
                        }
                    } catch (e) {
                        reject(e)
                    }
                }

                xhr.onerror = () => {
                    if (isAborted) {
                        reject(new Error('Request aborted'))
                        return
                    }
                    const err = new Error('Network Error')
                    if (config.requestLog) {
                        console.error('requestLog catch error', err)
                    }
                    reject(err)
                }

                xhr.onabort = () => {
                    reject(new Error('Request aborted'))
                }

                try {
                    xhr.send(defaultOptions.body as Document | XMLHttpRequestBodyInit | null)
                } catch (e) {
                    reject(e)
                }
            })
            
            const cancel = () => {
                isAborted = true
                if (xhr) {
                    xhr.abort()
                }
                if (abortController) {
                    abortController.abort()
                }
            }
            
            return {
                promise,
                cancel
            } as RequestResult<T>
        }
        
        // 非上传请求，返回 Promise（保持向后兼容）
        return new Promise<Response<T>>((resolve, reject) => {
            const signal = options?.signal
            
            // 设置超时时间，优先使用传入的 timeout，否则使用默认 30 分钟
            const timeout = options?.timeout || 30 * 60 * 1000; // 默认 30 分钟
            
            $fetch(url, {
                ...defaultOptions,
                signal,
                timeout: timeout
            }).then((res) => {
                let response = res as Response<T>
                if (config.requestLog) {
                    // console.log(`requestLog url: ${url} \n`, `params:`, params, '\n', 'response:', response,
                    //     "\n—————————————————————————————————————————————————————————————————"
                    // )
                }
                if (response.code === NetCode.TOKEN_EXPIRED) {
                    useUserStoreHook().tokenFail()
                    // const { $loginCom } = useNuxtApp();
                    // $loginCom.open();
                    resolve(response)
                } else if (response.code === NetCode.BIZ_DISABLE) {
                    if (response.message) {
                        Toast(response.message)
                    }
                    resolve(response)
                } else if (response.code === NetCode.BIZ_MEMBER_DISABLE) {
                    if (response.message) {
                        Toast(response.message)
                    }
                    resolve(response)
                }
                 else {
                    resolve(response)
                }
            }).catch(err => {
                if (config.requestLog) {
                    console.error('requestLog catch error', err)
                }
                reject(err)
            })
        })
    }

    static get<T = any>(url: string, params: any | null, options?: RequestOptions): Promise<Response<T>> {
        return HttpRequest.request<T>(url, 'get', params, options) as Promise<Response<T>>
    }

    static post<T = any>(url: string, params: any | null, options?: RequestOptions): Promise<Response<T>> | RequestResult<T> {
        return HttpRequest.request<T>(url, 'post', params, options)
    }
}

export default HttpRequest;
